module.exports = Object.freeze({
  /* BM Sign Errors */
  BMSIGN_MODIFIED_AGREEMENT: 'BMSIGN-MODIFIED-AGREEMENT',
  BMSIGN_SIGNER_COMPLETED: 'BMSIGN-SIGNER-COMPLETED',
  TOKEN_EXPIRED: 'TOKEN-EXPIRED',
  ENVELOPE_EXPIRED: 'ENVELOPE-EXPIRED',
})
